import React, { Suspense, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Preloader from './components/Preloader';

const Login = React.lazy(() => import('./components/Login'));
const Customers = React.lazy(() => import('./components/Customers'));
const Reservations = React.lazy(() => import('./components/Reservations'));
const Profile = React.lazy(() => import('./components/Profile'));
const EditReservation = React.lazy(() => import('./components/EditReservations'));
const Admin = React.lazy(() => import('./components/Admin'));
const RegisterUsers = React.lazy(() => import('./components/RegisterUser'));
const Diary = React.lazy(() => import('./components/Diary'));
const UserList = React.lazy(() => import('./components/usersList'));
const Finances = React.lazy(() => import('./components/Finances'));
const Store = React.lazy(() => import('./components/Store'));
const ReservationHistory = React.lazy(() => import('./components/ReservationHistory'));
const QuotaLimits = React.lazy(() => import('./components/QuotaLimits'));
const Summary = React.lazy(() => import('./components/Summary'));
const Pqrs = React.lazy(() => import('./components/Pqrs'));
const PqrsRequest = React.lazy(() => import('./components/PqrsRequest'));
const TermsAndConditionsView = React.lazy(() => import('./components/TermsAndConditionsView'));
const PublicTermsAndConditions = React.lazy(() => import('./components/PublicTermsAndConditions'));
const UserProgress = React.lazy(() => import('./components/UserProgress'));
const Statistics = React.lazy(() => import('./components/Statistics'));
const InterestedLeads = React.lazy(() => import('./components/InterestedLeads'));

function App() {
  const [currentUser, setCurrentUser] = useState(null);

  return (
    <Router>
      <Suspense fallback={<Preloader auto />}>
        <Routes>
          <Route path="/" element={<Login handleLogin={handleLogin} />} />
          <Route path="/customers/:id" element={<Customers currentUser={currentUser} />} />
          <Route path="/reservations/:id" element={<Reservations />} />
          <Route path="/profile/:id" element={<Profile />} />
          <Route path="/editReservation/:id" element={<EditReservation />} />
          <Route path="/admin/:id" element={<Admin currentUser={currentUser} />} />
          <Route path="/registerUsers/:id" element={<RegisterUsers />} />
          <Route path="/diary/:id" element={<Diary />} />
          <Route path="/userList/:id" element={<UserList />} />
          <Route path="/finances/:id" element={<Finances />} />
          <Route path="/store/:id" element={<Store />} />
          <Route path="/reservationHistory/:id" element={<ReservationHistory />} />
          <Route path="/quotaLimits/:id" element={<QuotaLimits />} />
          <Route path="/summary/:id" element={<Summary />} />
          <Route path='/pqrs/:id' element={<Pqrs />} />
          <Route path='/pqrsRequest/:id' element={<PqrsRequest />} />
          <Route path='/terminos&condiciones' element={<PublicTermsAndConditions />} />
          <Route path='/termsAndConditions/:id' element={<TermsAndConditionsView />} />
          <Route path='/userProgress/:id' element={<UserProgress />} />
          <Route path='/estadisticas/:id' element={<Statistics />} />
          <Route path='/interesados/:id' element={<InterestedLeads />} />
        </Routes>
      </Suspense>
      <ToastContainer />
    </Router>
  );

  function handleLogin(user) {
    setCurrentUser(user);
  }
}

export default App;
